'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('cast-contact-vote', {
      url: '/vote/:voteId/ballot/:id/contact/cast',
      template: '<cast-contact-vote></cast-contact-vote>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/cast-vote/contact/cast-contact-vote.routes.js